import { render, staticRenderFns } from "./ItemDespesaDetalhar.vue?vue&type=template&id=31daa66b"
import script from "./ItemDespesaDetalhar.vue?vue&type=script&lang=js"
export * from "./ItemDespesaDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports